<template>
    <div name="select-modal" class="wrapper">
        <div class="modal">
            <div class="touch" @click="onClose">

            </div>
            <div class="contents">
                <div class="button-box" @click="onClick(0)">
                    <img src="../../assets/booking.png" style="width: 84px;"/>
                    <span class="text">진료 예약하기</span>
                </div>
                <div class="button-box" @click="onClick(1)">
                    <img src="../../assets/medicals.png" style="width: 69px;"/>
                    <span class="text">진료 내역보기</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'selectModal',
    mounted: function()
    {
        const el = document.querySelector('.contents');
        const height = el.offsetHeight;

        const element = document.querySelector('.touch');       
        element.style.height = `calc(100vh - ${height}px)`;

        console.log('높이:', height);
    },  
    methods: {
        onClose : function()
        {
            this.$emit('onClose');
        },
        onClick: function(menu)
        {
            this.$emit('onClick', menu)
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        z-index: 1;
    }

    .modal {
        position: fixed;
        background: rgba(0, 0, 0, 0.7);
        max-width: 600px;
        width: 100%;
        height: 100vh;
        z-index: 11;
        bottom: 0;
        box-sizing: border-box;
    }
    .touch {
        width: 100vw;
    }
    .contents {
        background: #FFFFFF;
        width: calc(100%);
        border-top-left-radius: 23px;
        border-top-right-radius: 23px;
        padding: 30px 16px;
        display: flex;
        justify-content: center;
        align-items: flex-start;
        box-sizing: border-box;
        gap: 16px
    }
    .button-box {
        width: 166px;
        height: 166px;
        display: flex;
        justify-content: center;
        align-items: center;
        box-sizing: border-box;
        flex-direction: column;
        border-radius: 6px;
        background: var(--gray-20, #F3F5F8);
        cursor: pointer;
    }
    .text {
        color: var(--Gray-100, #1E1E1E);
        text-align: center;
        font-family: Pretendard;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        line-height: 20px; /* 125% */
    }
</style>


// WEBPACK FOOTER //
// src/components/my/SelectModal.vue